// import Header from '../../components/Header/Header';
import { useEffect, useState } from 'react';
import Menu from '../../components/Menu/Menu';
import './Home.scss';
export default function Home() {

    return (
        <div id="home">
            <div className='centered-container'>
                <Menu title="Ratonera" options={[
                    { name: 'Lists', path: '/lists', visible: ({ user }) => (user?.roles?.includes('developer') || user?.roles?.includes('lists')) },
                    { name: 'Immigration', path: '/immigration', visible: ({ user }) => (user?.roles?.includes('immigration') || user?.roles?.includes('root')) },
                    { name: 'Bus', path: '/bus', visible: ({ user }) => (user?.roles?.includes('tester') || user?.roles?.includes('root')) },
                    { name: 'Locations', path: '/locations', visible: ({ user }) => (user?.roles?.includes('locations') || user?.roles?.includes('root')) },
                    // { name: 'Tokipona', path: '/tokipona', visible: ({ user }) => user?.roles?.length > 0 },
                    // { name: 'Telegram', path: '/telegram', visible: ({ user }) => user?.roles?.length > 0 },
                    { name: 'Misc', path: '/misc', visible: ({ user }) => (user?.roles?.includes('developer') || user?.roles?.includes('git')) },
                    { name: 'About', path: '/about' },
                ]} />
            </div>
        </div>
    );
}
// scp -P 4022 -r build david@rattonera.duckdns.org:/home/david/tmp